/**
 * Magic to nudge the scroll position of an element by a certain amount
 *
 * @example
 *
 * <button x-on:click="$nudge($refs.someElement, 10)">Nudge!</button>
 */
// TODO test me
export default function nudge(_$el) {
  return (target, {left, top, ...options}) => {
    target.scrollTo({
      ...(left && {left: Math.max(Math.min(target.scrollLeft + left, target.scrollWidth), 0)}),
      ...(top && {left: Math.max(Math.min(target.scrollTop + top, target.scrollHeight), 0)}),
      ...options,
    });
  };
}
